// Configuration for Official WhatsApp Templates used across Usage MIS & Admin tools

export const WSP_TEMPLATES = [
  {
    id: "app_version",
    name: "app_version",
    title: "App Version Update (app_version)",
    header: "Important Version Update",
    bodyTemplate:
      "You may please note that Sahi Club version {{1}} is now available.\n\nPlease maintain the latest version for your team at {{2}} for secure and seamless access.",
    params: [
      {
        id: "1",
        key: "param1",
        label: "Version & Feature Highlights (Param 1)",
        placeholder: "e.g. v1.5 with (1) Meetings, (2) Sale Alerts, (3) Web Store",
        defaultValue: "v1.5 with (1) Meetings, (2) Sale Alerts, (3) Web Store",
        persist: true, // Persists across agencies
        helpText: "Enter the new version number and major features.",
      },
      {
        id: "2",
        key: "param2",
        label: "Company / Agency Name (Param 2)",
        placeholder: "e.g. Peach Technovations Pvt. Ltd.",
        defaultValueFromAgency: (agency) => agency?.agencyName || agency?.AgencyName || agency?.BizName || agency?.bizName || "",
        persist: false, // Automatically pulls the agency name for each row
        helpText: "Target company name mentioned in the message body.",
      },
    ],
    dynamicHeaderParams: [], // app_version header is static ("Important Version Update"), no dynamic {{1}} in header
    dynamicBtnParams: [], // static button
    button: {
      type: "url",
      label: "Update",
    },
  },
];

const STORAGE_KEY_PREFIX = "sahi_wsp_tmpl_param_";

/**
 * Get saved parameter value from storage
 */
export const getStoredParamValue = (templateName, paramKey, fallback = "") => {
  try {
    const saved = localStorage.getItem(`${STORAGE_KEY_PREFIX}${templateName}_${paramKey}`);
    return saved !== null ? saved : fallback;
  } catch (e) {
    return fallback;
  }
};

/**
 * Save parameter value into storage for future agencies
 */
export const setStoredParamValue = (templateName, paramKey, value) => {
  try {
    localStorage.setItem(`${STORAGE_KEY_PREFIX}${templateName}_${paramKey}`, value);
  } catch (e) {
    console.error("Failed to save parameter to storage", e);
  }
};
